




































































































import {
  MDialog,
  MDropdown,
  MDropdownItem,
  MIcon,
  MIconFile,
  MLink,
  MMessage,
  MPanel,
  MSpinner,
} from "@ulaval/modul-components";
import { Component, Vue } from "vue-property-decorator";
import BoutonsNavigation from "../components/BoutonsNavigation.vue";
import { Niveau } from "../models/Niveau";
import { Pavillon } from "../models/Pavillon";
import store, { modules } from "../store";

@Component({
  components: {
    MDialog,
    MDropdown,
    MDropdownItem,
    MSpinner,
    BoutonsNavigation,
    MMessage,
    MLink,
    MPanel,
    MIconFile,
    MIcon,
  },
})
export default class Emplacement extends Vue {
  private messageNiveau: string = "";
  private chargementEnCours: boolean = true;
  private afficherNiveau: boolean = false;
  private afficherPopUpNiveau: boolean = false;
  private afficherPlan: boolean = false;
  private isPlanPresent: boolean = false;
  private dirPlan: string = "/plans/";
  private urlPlan: string = "";

  protected async mounted(): Promise<void> {
    store.commit(modules.trainProgression.mutations.activerPrecedent.name);

    try {
      await store.dispatch(
        modules.cds.actions.recupererPavillonsAvecCasiersDispos.name,
        {
          idUtilisateur: this.$msal.data.query.profile?.id || "",
          vm: this,
        }
      );

      if (this.pavillonSelectionne !== "") {
        // Dans le cas où l'utilisateur avait déjà une sélection
        this.recupererNiveauxDuPavillon(this.pavillonSelectionne);

        if (this.niveauSelectionne !== "") {
          this.activerSuivant();
        }
      }
    } catch (e) {
      store.commit(
        modules.cds.mutations.recupererPavillonsAvecCasiersDisposEchec.name
      );
      store.commit(
        modules.utilisateur.mutations.sauvegarderPavillon.name,
        null
      );

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }

    this.chargementEnCours = false;
  }

  get pavillonSelectionne(): string {
    return store.state.utilisateur.pavillon?.id || "";
  }

  set pavillonSelectionne(idPavillon: string) {
    if (this.pavillonSelectionne !== idPavillon) {
      store.commit(modules.trainProgression.mutations.desactiverSuivant.name);
      this.afficherPlan = false;

      // Récupération du pavillon correspondant à l'identifiant reçu en paramètres.
      const pavillon = this.pavillons.find((p) => p.id === idPavillon);

      store.commit(
        modules.utilisateur.mutations.sauvegarderPavillon.name,
        pavillon
      );

      this.recupererNiveauxDuPavillon(idPavillon);
    }
  }

  get niveauSelectionne(): string {
    return store.state.utilisateur.niveau?.id || "";
  }

  set niveauSelectionne(idNiveau: string) {
    if (this.niveauSelectionne !== idNiveau) {
      // Récupération du niveau correspondant à l'identifiant reçu en paramètres.
      const niveau = this.niveaux.find((p) => p.id === idNiveau);

      store.commit(
        modules.utilisateur.mutations.sauvegarderNiveau.name,
        niveau
      );

      if (niveau?.message) {
        this.messageNiveau = niveau.message;
        this.afficherPopUpNiveau = true;
      } else {
        this.activerSuivant();
      }
    }
  }

  private activerSuivant(): void {
    this.rafraichirUrlPlan();
    this.afficherPlan = true;
    store.commit(modules.trainProgression.mutations.activerSuivant.name);
  }

  get pavillons(): Pavillon[] {
    return store.state.cds.pavillons;
  }

  get niveaux(): Niveau[] {
    return store.state.cds.niveaux;
  }

  private desactiverNiveau(niveau: Niveau): boolean {
    return (
      niveau.nombreCasiersDispos === 0 ||
      (niveau.typeClientele !== undefined &&
        store.state.utilisateur.typeClientele !== null &&
        niveau.typeClientele.id !== store.state.utilisateur.typeClientele.id)
    );
  }

  private async recupererNiveauxDuPavillon(idPavillon: string): Promise<void> {
    try {
      await store.dispatch(
        modules.cds.actions.recupererNiveauxAvecCasiersDispos.name,
        {
          pavillonId: idPavillon,
          idUtilisateur: this.$msal.data.query.profile?.id || "",
          vm: this,
        }
      );

      this.afficherNiveau = true;
    } catch (e) {
      store.commit(
        modules.cds.mutations.recupererNiveauxAvecCasiersDisposEchec.name
      );
      store.commit(modules.utilisateur.mutations.sauvegarderNiveau.name, null);

      store.commit(
        modules.applicatif.mutations.modifierMessageErreur.name,
        store.state.applicatif.messageErreurParDefaut
      );
    }
  }

  get niveau(): Niveau | null {
    return store.state.utilisateur.niveau;
  }

  get nomPlan(): string {
    var nomPlanTemp: string = this.niveau?.nomPlan || "";

    this.isPlanPresent = nomPlanTemp.length > 0;

    return nomPlanTemp;
  }

  get nomNiveau(): string {
    return this.niveau?.nomNiveau || "";
  }

  private rafraichirUrlPlan(): void {
    this.urlPlan = this.dirPlan + this.nomPlan;
  }
}
